<template>
  <div class="announcement-add">
    <Row :gutter="16">
      <i-col span="20">
        <Form ref="newForm" :model="model"
          :rules="modelValidate"
          label-position="right"
          :label-width="160">
          <FormItem label="标题" prop="title">
            <Input v-model="model.title"
              placeholder="请输入标题" />
          </FormItem>
          <FormItem label="类型" prop="type">
            <RadioGroup v-model="model.type" type="button" button-style="solid">
              <Radio :label="0">公告</Radio>
              <Radio :label="1">公示</Radio>
              <Radio :label="2">政策法规</Radio>
              <Radio :label="3">通知</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="行业/领域" prop="industryId">
            <Select v-model="model.industryId" filterable placeholder="选择专属行业/领域">
              <Option :value="null" v-if="checkRolePermitted(['总监管人'])">不限</Option>
              <Option v-for="item in industries" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="地区" prop="cityId">
            <i-switch v-model="restrictCity" size="large">
              <span slot="open">指定</span>
              <span slot="close">不限</span>
            </i-switch>
            <template v-if="restrictCity">
              <Cascader
                v-if="checkRolePermitted(['总监管人'])"
                v-model="model.cities"
                :data="cities"
                :load-data="loadCityData"
                @on-change="citySelected"
                placeholder="选择"
              ></Cascader>
              <Select
                v-else-if="checkRolePermitted(['监管人'])"
                v-model="model.cityId"
                filterable
                placeholder="选择地区"
              >
                <Option v-for="item in cities" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </template>
          </FormItem>
          <FormItem label="公开" prop="isPublic">
            <i-switch v-model="model.isPublic">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </FormItem>
          <FormItem label="置顶" prop="isTop">
            <i-switch v-model="model.isTop">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </FormItem>
          <FormItem label="内容" prop="content">
            <Input v-model="model.content"
              type="textarea"
              :rows="20"
              placeholder="请输入内容" />
          </FormItem>
          <FormItem
            label="附件(如有)">
            <Upload
              ref="attachmentUploader"
              :data="OSSParam"
              :before-upload="handleBeforeUpload"
              :multiple="true"
              :max-size="5120000"
              :on-success="handleUploadSuccess"
              :on-exceeded-size="handleExceededSize"
              :on-remove="removeItem"
              :on-preview="previewUploaded"
              :show-upload-list="false"
              :action="uploadParams.host">
              <Button @click="getOSSParam"><Icon type="ios-cloud-upload-outline"></Icon>上传附件</Button>
            </Upload>
            <div class="attachments">
              <div class="attachment-thumb"
                @click="previewImgUrl=item;showPreview=true"
                :key="index"
                v-for="(item,index) in model.attachments">
                <img :src="item.url" v-if="item&&item.url&&item.type==='image'">
                <span style="font-weight:bold;color:#999" v-if="item&&item.url&&item.type==='file'">{{item.surfix.toUpperCase()}}</span>
                <div class="attachment-thumb-cover">
                  <Icon type="ios-eye-outline" @click.stop="previewImgUrl=item;showPreview=true"></Icon>
                  <Icon type="ios-trash-outline" @click.stop="removeItem(item)"></Icon>
                </div>
              </div>
            </div>
          </FormItem>
          <FormItem label="来源" prop="origin">
            <Input v-model="model.origin"
              placeholder="请输入来源" />
          </FormItem>
          <FormItem label="原网址" prop="refer">
            <Input v-model="model.refer"
              placeholder="请输入原网址" />
          </FormItem>
          <FormItem>
            <Button type="primary" size="large" long @click="submit">保存</Button>
          </FormItem>
        </Form>
      </i-col>
      <i-col span="8">
      </i-col>
    </Row>
    <Modal v-model="showPreview" title="查看图片" @on-cancel="showPreview=false;previewImgUrl=null">
      <img :src="previewImgUrl" v-if="showPreview&&typeof(previewImgUrl)==='string'" style="width: 100%">
      <img :src="previewImgUrl.url" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='image'" style="width: 100%">
      <a :href="previewImgUrl.url" target="_blank" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='file'">查看</a>
    </Modal>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'announcement-add',
  props: {
  },
  data () {
    return {
      loading: false,
      industries: [],
      cities: [],
      restrictCity: false,
      model: {
        industryId: null,
        cityId: null,
        title: null,
        content: null,
        attachments: [],
        type: 0, // 0-公告|1-公示|2-政策法规
        contentType: 0, // 0-text|1-html
        isPublic: true,
        isTop: false,
        origin: null,
        refer: null
      },
      modelValidate: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '内容不能为空', trigger: 'blur' }
        ]
      },
      uploadParams: {
        accessid: '',
        host: '',
        policy: '',
        signature: '',
        callbackbody: '',
        key: '',
        expire: 0
      },
      OSSParams: [],
      OSSParam: {
        name: '',
        key: '',
        policy: '',
        OSSAccessKeyId: '',
        success_action_status: '200',   // 让服务端返回200,不然，默认会返回204
        signature: '',
        fileIndex: 0
      },
      curOSSParamIndex: 0,
      previewImgUrl: null,
      showPreview: false
    }
  },
  watch: {
  },
  mounted () {
    if (!this.checkRolePermitted(['总监管人', '监管人'])) {
      this.$Modal.error({
        title: '错误',
        content: '无权访问该页面',
        onOk: () => {
          this.$router.back()
        }
      })
    } else if (this.checkRolePermitted(['总监管人'])) {
      this.initIndustrySelect()
      this.initCitySelect()
    } else if (this.$common.userType[this.$store.getters.userInfo.type.toString()] === '监管人') {
      if (this.$store.getters.supervisorInfo.industries.length === 1) {
        this.model.industryId = this.$store.getters.supervisorInfo.industries[0].industry.id
      }
      this.industries = this.$store.getters.supervisorInfo.industries.map((i) => {
        return {
          id: i.industry.id,
          value: i.industry.id,
          label: i.industry.name
        }
      })
      if (this.$store.getters.supervisorInfo.cities.length === 1) {
        this.model.cityId = this.$store.getters.supervisorInfo.cities[0].city.id
      }
      this.cities = this.$store.getters.supervisorInfo.cities.map((i) => {
        return {
          id: i.city.tid,
          value: i.city.tid,
          label: i.city.name
        }
      })
    }
  },
  activated () {
  },
  deactivated () {
  },
  computed: {
  },
  methods: {
    getConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    initIndustrySelect () {
      this.$Api.Industry.listIndustries({
      }, 1, 1000).then((res) => {
        let data = res.data.map((c) => {
          return {
            id: c.id,
            value: c.id,
            label: c.name
          }
        })
        this.industries = data
      }).catch(err => {
        this.$Message.error('获取行业列表失败!' + err.message)
      })
    },
    initCitySelect () {
      this.$Api.City.listCities({
        tier: 1,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          return {
            id: c.tid,
            value: c.tid,
            label: c.name,
            tier: c.tier,
            parent: c.parent,
            loading: false,
            children: []
          }
        })
        this.cities = data
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
      })
    },
    loadCityData (item, callback) {
      item.loading = true
      let parentId = item.value
      let tier = item.tier || 0
      let curNode = null
      if (tier === 1) {
        curNode = this.cities.filter((c) => {
          return c.id === item.id
        })[0]
      } else {
        let parentNode = this.cities.filter((c) => {
          return c.id === item.parent
        })
        curNode = parentNode[0]
      }
      console.log(curNode)
      this.$Api.City.listCities({
        tier: tier + 1,
        parentId: parentId,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          if (tier === 1) {
            return {
              id: c.tid,
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent,
              loading: false,
              children: []
            }
          } else {
            return {
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent
            }
          }
        })
        let retData = [{
          value: parentId,
          label: '本级'
        }]
        data.forEach((d) => {
          retData.push(d)
        })
        if (tier === 0) {
          curNode = retData
        } else {
          item.children = retData
        }
        item.loading = false
        callback()
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
        item.loading = false
        callback()
      })
    },
    citySelected (val) {
      if (val instanceof Array) {
        this.model.cityId = val[val.length - 1]
      } else {
        this.model.cityId = val
      }
    },
    async submit () {
      this.$refs.newForm.validate(async (valid) => {
        if (valid) {
          this.$Modal.confirm({
            title: '确认操作',
            content: '<p>确认提交么？</p>',
            onOk: () => {
              this.doSubmit()
            }
          })
        }
      })
    },
    async doSubmit () {
      this.loading = true
      this.$Spin.show()
      let model = Object.assign({}, this.model)
      let urls = []
      urls = model.attachments.map((att) => {
        return att.name.replace('oss:', '')
      })
      model.attachments = urls
      await Api.Announcement.add(model)
        .then((payload) => {
          console.log('suc', payload)
          this.$Message.success('新增成功!')
          this.model= {
            industryId: null,
            cityId: null,
            title: null,
            content: null,
            attachments: [],
            type: 0, // 0-公告|1-公示
            contentType: 0, // 0-text|1-html
            isPublic: true,
            isTop: false,
            origin: null,
            refer: null
          }
          this.loading = false
          this.$Spin.hide()
          this.$router.back()
        })
        .catch(err => {
          console.log('err', err)
          this.$Message.error('提交失败!' + err.message)
          this.loading = false
          this.$Spin.hide()
        })
    },
    getOSSParam () {
      // type: 1-合同|2-竣工|3-其他
      this.$Api.Guarantee.getUploadParams(3).then((res) => {
        console.log(res)
        this.uploadParams = {
          accessid: res.accessid,
          host: res.host,
          policy: res.policy,
          signature: res.signature,
          callbackbody: res.callbackbody,
          key: res.dir,
          expire: res.expire
        }
        this.uploadParams.host = this.uploadParams.host.replace('-internal', '')
      }).catch(err => {
        this.$Message.error(err.message)
      })
    },
    handleBeforeUpload (file) {
      let filename = this.uploadParams.key + this.randomString(10) + this.getSuffix(file.name)
      this.OSSParam.name = file.name
      this.OSSParam.key = filename
      this.OSSParam.policy = this.uploadParams.policy
      this.OSSParam.OSSAccessKeyId = this.uploadParams.accessid
      this.OSSParam.success_action_status = '200'   // 让服务端返回200,不然，默认会返回204
      this.OSSParam.signature = this.uploadParams.signature
    },
    async handleUploadSuccess (response, file) {
      let filename = 'oss:' + this.OSSParam.key
      file.name = filename
      this.$nextTick(async () => {
        await this.procOssKey(filename).then(url => {
          url.status = 'finished'
          this.model.attachments.push(Object.assign({
            name: file.name,
            ossKey: filename
          }, url))
        })
      })
    },
    removeItem (item) {
      let attach = this.model.attachments
      let idx = attach.findIndex(o => o.name === item.name)
      attach.splice(idx, 1)
    },
    previewUploaded (file) {
      let key = file.name.indexOf('oss:') === 0 ? file.name.substr(4) : file.name
      this.procOssKey(key).then((obj) => {
        console.log(obj)
        this.previewImgUrl = obj.url
        this.showPreview = true
      })
    },
    async procOssKey (k) {
      let url = await this.procOSSUrl(k)
      return new Promise((resolve) => {
        let surfix = url.substr(url.lastIndexOf('.') + 1).toLowerCase()
        if (surfix.indexOf('?')) {
          surfix = surfix.substring(0, surfix.indexOf('?'))
        }
        let type = 'image'
        switch (surfix) {
          case 'jpg':
            type = 'image'
            break
          case 'jpeg':
            type = 'image'
            break
          case 'png':
            type = 'image'
            break
          case 'gif':
            type = 'image'
            break
          case 'pdf':
            type = 'file'
            break
          case 'doc':
            type = 'file'
            break
          case 'docx':
            type = 'file'
            break
          case 'xls':
            type = 'file'
            break
          case 'xlsx':
            type = 'file'
            break
          case 'ppt':
            type = 'file'
            break
          case 'pptx':
            type = 'file'
            break
          default:
            type = 'file'
            break
        }
        resolve({
          name: k,
          url,
          type,
          surfix
        })
      })
    },
    procOSSUrl (_key) {
      return new Promise((resolve, reject) => {
        let url = ''
        let ossKey = window.encodeURIComponent(window.btoa(_key))
        Api.Guarantee.getOssUrl(ossKey).then((res) => {
          // console.log(typeof(res), res)
          url = res
          resolve(url)
        }).catch(err => {
          this.$Message.error('获取文件地址失败!' + err.message)
          reject(err)
        })
      })
    },
    handleExceededSize () {
      this.$Notice.warning({
        title: '文件大小超出限制',
        desc: '上传文件大小超出限制范围。'
      })
    },
    randomString (len) {
      len = len || 32
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      var maxPos = chars.length
      var pwd = ''
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },
    getSuffix (filename) {
      let pos = filename.lastIndexOf('.')
      let suffix = ''
      if (pos !== -1) {
        suffix = filename.substring(pos)
      }
      return suffix
    },
  }
}
</script>

<style lang="less" scoped>
.attachments {
  display: flex;
  flex-direction: row;
  margin: 10px 0;
}
.attachment-thumb {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-color: #efefef;
  width: 100px;
  height: 100px;
  margin-right: 4px;
  transition: all .2s ease-in-out;
  cursor: pointer;
  padding: 3px;
  border: 1px solid #d2d2d2;
  position: relative;
  &:hover {
    border: 1px solid rgb(65,157,253);
    background-color: #fff;
  }
  overflow: hidden;
  img {
    width: 100%;
  }
  .attachment-thumb-cover{
    opacity: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
    transition: all .3s linear;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  &:hover .attachment-thumb-cover{
    opacity: 1;
  }
  .attachment-thumb-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 5px;
  }
}
</style>
